import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";

export default class Appbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <AppBar
        position="sticky"
        color="default"
        elevation={0}
        style={{ backgroundColor: "white" }}
      >
        <Toolbar>
          <a href="#home" style={styles.links}>
            <IconButton color="inherit" aria-label="Menu">
              TL
            </IconButton>
          </a>
          <Typography
            variant="title"
            color="inherit"
            style={{ display: "flex", flex: 1 }}
          />
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "flex-end",
              justifyContent: "flex-end"
            }}
          >
            <a href="#intro" style={styles.links}>
              <Button color="inherit">about</Button>
            </a>
            <a href="#services" style={styles.links}>
              <Button color="inherit">services</Button>
            </a>
            <a href="#projects" style={styles.links}>
              <Button color="inherit">Projects</Button>
            </a>
            {/*
            <a href="#interests" style={styles.links}>
              <Button color="inherit">Interests</Button>
            </a>*/}
            <a href="#contact" style={styles.links}>
              <Button color="inherit">Contact</Button>
            </a>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

const styles = {
  links: {
    textDecoration: "none",
    color: "black"
  }
};



// WEBPACK FOOTER //
// ./src/appbar.js